import {stringToBoolean} from 'shared/web';

import {WarehouseDirectSaleVariantsDetailFormSchemaType} from '../types/WarehouseDirectSaleVariantsDetailFormSchema';

// A VAT deductible variant has no fixed VAT rate, so the stored rate is dropped from the payload.
export function buildAccountingPatchBody(
  accounting: WarehouseDirectSaleVariantsDetailFormSchemaType['accounting']
) {
  const isTaxDeductible = stringToBoolean(accounting.isTaxDeductible);

  return {
    ...accounting,
    isTaxDeductible,
    fixedVatType: isTaxDeductible ? undefined : accounting.fixedVatType,
  };
}
